const configData = {
  audio_legth: 40 * 1024 * 1024,
  audio_duration: 1 * 60 * 60,
  video_legth: 100 * 1024 * 1024,
  video_duration: 1 * 60 * 60,
}

export default configData
